import 'bootstrap/js/dist/carousel.js';
import ResponsiveImages from './ResponsiveImages';
import BootstrapCarousel from '../vendor/BootstrapCarousel';

export default class AchievementsCarousel {
    static init() {
        BootstrapCarousel.init();
        ResponsiveImages.setCarouselHiddenImagesSizesAttributes(
            '#achievements-carousel',
            '.carousel-item.active > img',
            '.carousel-item:not(.active) > img'
        );
        const carouselLink = document.querySelector('[data-carousel-link]');
        const carousel = document.querySelector('#achievements-carousel');
        if (carousel) {
            carousel.addEventListener('slid.bs.carousel', function ({relatedTarget}) {
                if (carouselLink) {
                    carouselLink.setAttribute('href', relatedTarget.dataset.href);
                }
            });
        }
    }
}
